export default __webpack_public_path__ + "364cd9d045c147b06bbf0d3e6106789e.svg";